import { formatCoordinates, formatDistance } from '../../services/scan/geolocation'
import { IconPin } from './ScanIcons'

function StoreSummary({ name, address, coords, onEdit }) {
  return (
    <div className="scan-store-summary">
      <div>
        <strong>{name || 'Position enregistrée'}</strong>
        {address ? <p>{address}</p> : null}
        {coords?.lat != null && coords?.lng != null ? (
          <small>{formatCoordinates(coords)}</small>
        ) : null}
      </div>
      {onEdit ? (
        <button type="button" className="scan-ghost scan-store-change" onClick={onEdit}>
          Modifier
        </button>
      ) : null}
    </div>
  )
}

export default function ScanStorePicker({
  status,
  places,
  selected,
  storeName,
  storeAddress,
  query,
  error,
  coords,
  onAskLocation,
  onSearch,
  onQueryChange,
  onSelect,
  onNameChange,
  onAddressChange,
  onSavePositionOnly,
  onEditAssociation,
}) {
  const locating = status === 'locating'
  const hasCoords = coords?.lat != null && coords?.lng != null
  const associated = Boolean(selected) || status === 'coords-only'
  const showSearch = !associated

  return (
    <section className="scan-field scan-store-section">
      <label htmlFor="scan-store-query">Coordonnées géographiques du point de vente</label>
      {associated ? (
        <StoreSummary
          name={selected?.name || storeName}
          address={selected?.address || storeAddress}
          coords={{
            lat: selected?.lat ?? coords?.lat,
            lng: selected?.lng ?? coords?.lng,
            accuracy: selected?.accuracy ?? coords?.accuracy,
          }}
          onEdit={onEditAssociation}
        />
      ) : (
        <p className="scan-product-hint">Associer l’emplacement de ce produit.</p>
      )}
      {showSearch ? (
        <>
          <div className={`scan-store-search${locating ? ' is-locating' : ''}`}>
            <input
              id="scan-store-query"
              value={query}
              placeholder="Rechercher un magasin"
              onChange={(event) => onQueryChange(event.target.value)}
              onKeyDown={(event) => {
                if (event.key === 'Enter') {
                  event.preventDefault()
                  onSearch()
                }
              }}
            />
            <button
              type="button"
              className="scan-store-geo"
              onClick={onAskLocation}
              disabled={locating}
              aria-label="Utiliser ma position"
              aria-busy={locating || undefined}
              title="Utiliser ma position"
            >
              <IconPin />
            </button>
          </div>
          {locating ? <p className="scan-product-hint">Recherche des commerces proches…</p> : null}
          {status === 'denied' || status === 'error' ? (
            <p className="scan-product-hint" role="status">{error || 'Localisation refusée. Saisie manuelle disponible.'}</p>
          ) : null}
          {hasCoords && !locating ? (
            <p className="scan-store-coords" aria-live="polite">{formatCoordinates(coords)}</p>
          ) : null}
          {places.length ? (
            <div className="scan-store-list">
              {places.map((place) => (
                <button
                  key={`${place.placeId || place.name}-${place.address || ''}`}
                  type="button"
                  className="scan-store-option"
                  onClick={() => onSelect(place)}
                >
                  <strong>{place.name}</strong>
                  <small>{[place.address, formatDistance(place.distance)].filter(Boolean).join(' · ')}</small>
                </button>
              ))}
            </div>
          ) : null}
          {hasCoords ? (
            <button
              type="button"
              className="scan-store-save-position"
              onClick={onSavePositionOnly}
              disabled={locating}
              aria-label="Enregistrer les coordonnées géographiques actuelles"
            >
              <IconPin />
              <span>{locating ? 'Localisation…' : 'Enregistrer les coordonnées géographiques actuelles'}</span>
            </button>
          ) : null}
          {status === 'denied' || status === 'error' || (hasCoords && !places.length) ? (
            <>
              <input value={storeName} placeholder="Nom du magasin" onChange={(event) => onNameChange(event.target.value)} />
              <textarea rows={2} value={storeAddress} placeholder="Adresse complète" onChange={(event) => onAddressChange(event.target.value)} />
            </>
          ) : null}
        </>
      ) : null}
    </section>
  )
}
